// test1185
(1185 && 0);
